<script>
import {mapState} from 'vuex';

export default {
    computed: {
        ...mapState({
            cancellationRules: state => state.contract.contract.item.cancellationRules.cancellationRules
        })
    }
}
</script>
<template>
    <div class="contract-form-cancellation-rules">
        <div class="contract-form-cancellation-rules__heading">
            {{ $t('contract.form.cancellationRules.heading') }}
        </div>
        <table class="contract-form-cancellation-rules__table">
            <thead>
                <tr>
                    <th>{{ $t('contract.form.cancellationRules.labels.days') }}</th>
                    <th>{{ $t('contract.form.cancellationRules.labels.percent') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(rule, index) in cancellationRules" :key="index">
                    <td>
                        <span>{{ rule.days }}</span>
                        <span v-if="rule.noShow">{{ $t('contract.form.cancellationRules.noShow') }}</span>
                    </td>
                    <td>{{ rule.percent }}%</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractFormCancellationRules/ContractFormCancellationRules.vue